var __jsx = React.createElement;
import React from "react";
import { jsx as ___EmotionJSX } from "@emotion/core";
const Singapore = () => {
  return ___EmotionJSX("svg", {
    fill: "none",
    height: "15",
    viewBox: "0 0 20 15",
    width: "20",
    xmlns: "http://www.w3.org/2000/svg"
  }, ___EmotionJSX("mask", {
    height: "15",
    id: "mask0_305_22707",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    },
    width: "20",
    x: "0",
    y: "0"
  }, ___EmotionJSX("rect", {
    fill: "white",
    height: "15",
    width: "20"
  })), ___EmotionJSX("g", {
    mask: "url(#mask0_305_22707)"
  }, ___EmotionJSX("path", {
    clipRule: "evenodd",
    d: "M0 0V15H20V0H0Z",
    fill: "#F7FCFF",
    fillRule: "evenodd"
  }), ___EmotionJSX("mask", {
    height: "15",
    id: "mask1_305_22707",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    },
    width: "20",
    x: "0",
    y: "0"
  }, ___EmotionJSX("path", {
    clipRule: "evenodd",
    d: "M0 0V15H20V0H0Z",
    fill: "white",
    fillRule: "evenodd"
  })), ___EmotionJSX("g", {
    mask: "url(#mask1_305_22707)"
  }, ___EmotionJSX("path", {
    clipRule: "evenodd",
    d: "M0 0V7.5H20V0H0Z",
    fill: "#E31D1C",
    fillRule: "evenodd"
  }), ___EmotionJSX("path", {
    clipRule: "evenodd",
    d: "M5.54277 6.61853C5.54277 6.61853 3.77671 5.90823 3.77671 3.98381C3.77671 2.05938 5.54277 1.37202 5.54277 1.37202C4.68443 1.15473 2.40686 1.34908 2.40686 3.98381C2.40686 6.61853 4.65002 7.11541 5.54277 6.61853ZM5.99525 6.30044L6.50189 5.99458L7.01969 6.30044L6.89297 5.70359L7.3139 5.23275H6.74359L6.50189 4.67544L6.26019 5.23275L5.6889 5.2569L6.11081 5.70359L5.99525 6.30044ZM8.34333 5.96043L7.83669 6.26629L7.95225 5.66944L7.53034 5.22275L8.10163 5.1986L8.34333 4.64129L8.58503 5.1986H9.15534L8.7344 5.66944L8.86113 6.26629L8.34333 5.96043ZM7.05448 3.60622L7.56112 3.30036L8.07893 3.60622L7.9522 3.00937L8.37314 2.53853H7.80282L7.56112 1.98122L7.31943 2.53853L6.74814 2.56268L7.17005 3.00937L7.05448 3.60622ZM5.85613 4.51421L5.34949 4.82007L5.46505 4.22322L5.04314 3.77653L5.61443 3.75238L5.85613 3.19507L6.09783 3.75238H6.66814L6.24721 4.22322L6.37394 4.82007L5.85613 4.51421ZM8.6985 4.79266L9.20514 4.4868L9.72294 4.79266L9.59622 4.19581L10.0172 3.72497H9.44684L9.20514 3.16766L8.96344 3.72497L8.39215 3.74912L8.81406 4.19581L8.6985 4.79266Z",
    fill: "#F1F9FF",
    fillRule: "evenodd"
  }))), ___EmotionJSX("rect", {
    height: "14",
    rx: "0.5",
    stroke: "#E8E7E4",
    width: "19",
    x: "0.5",
    y: "0.5"
  }));
};
export default Singapore;
//# sourceMappingURL=Singapore.js.map
// @zapier/checkout@7.9.7 (23abc9ace)
